"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANALYSIS_CONSTS = void 0;
exports.ANALYSIS_CONSTS = {
    AnalysisUuidMetadataKey: 'analysisUuid',
    ManualProductMetadataKey: 'manualProduct',
};
